import React from "react";
import Div from "@jumbo/shared/Div";
import PricingPlan from "../Pricing/PricingList";
import ProgrammingLanguagesPage from "../ProgrammingContent/ProgrammingLanguagesPage";
import HeroSection from "./HeroSection";
import FeaturesSection from "./FeaturesSection";
import TagsSection from "./TagsSection";
import useAdmin from "app/routes/middleware/Admin/useAdmin";
import useMetaTitle from "app/hooks/useMetaTitle";

const HomePage = () => {
  const isAdmin = useAdmin();

    useMetaTitle({
      title: "Codingpal",
    });
  
  return isAdmin ? (
    <ProgrammingLanguagesPage />
  ) : (
    <Div
      sx={{
        maxWidth: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <HeroSection />

      <FeaturesSection />

      <TagsSection />

      <PricingPlan />
    </Div>
  );
};

export default HomePage;
